export default "__VITE_PUBLIC_ASSET__c8a3c5fc__"